import script from "./TextInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=e5c6b27c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5c6b27c"]])

export default __exports__